var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 50,
    viewBox: "0 0 224 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.92924L3.33923 6.59001C6.67846 3.25078 13.3569 -3.42768 20.0354 2.13771C26.7138 7.70309 33.3923 25.5123 41.1838 35.53C47.8623 45.5477 54.5408 47.7738 61.2192 43.3215C67.8977 38.8692 74.5761 27.7385 81.2546 22.1731C87.9331 16.6077 94.6115 16.6077 101.29 16.6077C107.968 16.6077 115.76 16.6077 122.438 15.4946C129.117 14.3815 135.795 12.1554 142.474 7.70309C149.152 3.25078 155.831 -3.42768 162.509 3.25078C169.188 9.92924 175.866 29.9646 182.545 32.1908C190.336 34.4169 197.015 18.8339 203.693 12.1554C210.371 5.47694 217.05 7.70309 220.389 8.81617L223.728 9.92924V50H220.389C217.05 50 210.371 50 203.693 50C197.015 50 190.336 50 182.545 50C175.866 50 169.188 50 162.509 50C155.831 50 149.152 50 142.474 50C135.795 50 129.117 50 122.438 50C115.76 50 107.968 50 101.29 50C94.6115 50 87.9331 50 81.2546 50C74.5761 50 67.8977 50 61.2192 50C54.5408 50 47.8623 50 41.1838 50C33.3923 50 26.7138 50 20.0354 50C13.3569 50 6.67846 50 3.33923 50H0V9.92924Z",
    fill: "url(#paint0_linear_203_1008)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_1008",
    x1: 111.864,
    y1: 0,
    x2: 111.864,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A034FA",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A034FA",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph4);
export default __webpack_public_path__ + "static/media/graph4.583f920b3988326153d5c067006970a9.svg";
export { ForwardRef as ReactComponent };